import request from '../../../api/request';
import {
  StudyPlanOffersLoaderQuery,
  StudyPlanOffersResponseType,
  PeriodsResponseType,
  SetInterviewRequiredDto,
} from './types';

const ENROLLMENT_AND_TUITION_CONFIG_ENDPOINT =
  'maintainers-portal/general-configuration/enrollment-and-tuition-configuration';

export function getStudyPlanOffers(query: StudyPlanOffersLoaderQuery) {
  const route = ENROLLMENT_AND_TUITION_CONFIG_ENDPOINT;
  return request<StudyPlanOffersResponseType>(route, {
    params: { periodId: query.periodId },
  });
}

export function getPeriods() {
  return request<PeriodsResponseType>(
    `${ENROLLMENT_AND_TUITION_CONFIG_ENDPOINT}/periods`,
  );
}

export function setInterviewRequired(data: SetInterviewRequiredDto) {
  return request<void>(
    `${ENROLLMENT_AND_TUITION_CONFIG_ENDPOINT}/set-interview-required`,
    {
      method: 'POST',
      data,
    },
  );
}
